import React, { useState, useEffect, useRef, useContext } from "react";

// ------------------ COMPONENTES DE PRIMEREACT --------------------------
import { Button, ConfirmDialog, Dialog, InputText, Toast } from "primereact";
import { Checkbox } from "primereact/checkbox";

// ------------------ COMPONENTES DE BASE --------------------------------
import { useForm } from "../../../../../Base/Hooks/useForm";
import Loader from "../../../../../Base/Components/Loader/Loader";
import { toastShow } from "../../../../../Base/Services/ToastService";
import { AuthContext } from "../../../../../Base/Context/AuthContext/AuthContext";
import { getTypesCategoria } from "../../../../../Base/API/Global/Types/TypeRequest";
import AutoCompleteDropdown from "../../../../../Base/Components/Form/AutoCompleteDropdown";
import { addCategoria, obtenerCategoriasAct } from "../../../../../Base/API/Global/Categorias/CategoriasRequests";

// ------------------- CONSULTAS A LA API ---------------------------------
import { getEstadosCategory } from "../../../../../API/Global/Status/StatusRequests";

const CategoriasCrudModal = ({
  categoria,
  categoriasDialog,
  setCategoriasDialog,
  toastRef,
  getCategorias,
  modo,
}) => {
  const toastDialog = useRef(null);
  const toast = useRef(null);

  const [show, setShow] = useState(false);

  const [estados, setEstados] = useState([{}]);
  const [categ, setCateg] = useState([{}]);
  const [loading, setLoading] = useState(false);
  const { userAuth } = useContext(AuthContext);
  const [tiposCategoria, setTipoCategoria] = useState([{}]);

  const initialValues = {
    IdCategoria: -1,
    NombreCategoria: "",
    Comentario: "",
    IdStatus: categoria ? categoria?.IdStatus : 5,
    IdType: null
  };

  const { values, handleInputChange, setValues, resetForm, error, setError } = useForm(initialValues);

  const getValoresIniciales = async () => {
    setLoading(true)
    const estadosTempo = await getEstadosCategory("General");
    setEstados(estadosTempo);

    const cat = await obtenerCategoriasAct();
    setCateg(cat);

    const types = await getTypesCategoria("Productos");
    setTipoCategoria(types);

    // Si el modo es "Crear", establece el primer estado como valor inicial
    const estadoInicial = modo === "Crear" ? estadosTempo[0] : estadosTempo.find((e) => e.IdStatus === categoria?.IdStatus);

    setValues({
      ...categoria,
      Estado: estadoInicial, // Establece el estado inicial
      IdStatus: estadoInicial.IdStatus, // Establece el IdStatus en values
      Tipo: modo === "Crear" ? null : types.find((t) => t.IdType === categoria?.IdType)
    });
    setLoading(false)
  };

  const onHide = () => {
    setCategoriasDialog(false);
    resetForm();
    setShow(false);
  };

  const verificarInfo = () => {
    let error = {};
    if (!values.NombreCategoria) {
      error.NombreCategoria = true;
      error.error = true;
    }
    if (!values.Estado || !values.Estado.IdStatus) {
      error.IdStatus = true;
      error.error = true;
    }
    if (!values.Tipo || !values.Tipo.IdType) {
      error.IdType = true;
      error.error = true;
    }
    if (!/^[A-Za-z0-9ÁÉÍÓÚáéíóúÑñ\s.\-_]*$/.test(values.Comentario)) {
      error.Comentario = true;
      error.error = true;
    }
    setError(error);
    return error;
  };

  const agregarCategoria = async () => {
    const e = verificarInfo();
    if (!e.error) {
      const existingCategory = categ.find(
        (cur) => cur.NombreCategoria === values?.NombreCategoria
      );
      if (
        existingCategory &&
        (modo === "Crear" ||
          existingCategory.IdCategoria !== values.IdCategoria)
      ) {
        toastShow(
          toast,
          "error",
          "Error",
          "Ya existe un tipo de producto con ese nombre"
        );
      } else {
        let estadoId = null;
        if (values.Estado) {
          estadoId = values.Estado.IdStatus;
        }
        const a = {
          IdCategoria: values?.IdCategoria,
          NombreCategoria: values.NombreCategoria,
          Comentario: values.Comentario,
          IdStatus: estadoId,
          IdUserCreate: userAuth?.IdUser,
          IdType: values.Tipo.IdType
        };

        await addCategoria(a);
        if (modo === "Crear") {
          onHide();
          toastShow(toastRef, "success",  "Datos Agregados", "Tipo Producto Agregado exitosamente.");
          getCategorias();
        } else {
          onHide();
          toastShow(toastRef, "success", "Datos Agregados","Tipo Producto modificado exitosamente.");
          getCategorias();
        }
      }
    }
  };

  const DialogFooter = (
    <React.Fragment>
      <Button
        label="Cancelar"
        icon="pi pi-times"
        className="p-button-text"
        onClick={onHide}
      />
      <Button
        label={modo === "Crear" ? "Guardar" : "Modificar"}
        icon="pi pi-check"
        className="p-button-text"
        onClick={() => {
          if (modo === "Crear") {
            agregarCategoria();
          } else {
            agregarCategoria();
          }
        }}
        loading={loading}
      />
    </React.Fragment>
  );

  useEffect(() => {
    if (categoriasDialog) {
      getValoresIniciales();
    }
  }, [categoriasDialog]);


  const dialogTitle = modo === "Crear" ? "Agregar Categoría" : "Modificar Categoría";

  return (
    <div>
      <Toast ref={toast} style={{ zIndex: 50000 }} />
      <ConfirmDialog />
      <Dialog
        visible={categoriasDialog}
        modal
        className="modal__contenedor modal__usuarios"
        footer={DialogFooter}
        onHide={onHide}
      >
        <div id="Dialog">
          <Loader loading={loading} querySelector={"#Dialog"} />
          <div style={{ width: "100", margin: "auto" }}>
            <div className="d-flex align-items-center">
              <h2 className="me-3">{dialogTitle}</h2>
            </div>
            <Toast ref={toastDialog} style={{ zIndex: 50000 }} />

            <div className="modal__input-contenedor">
              <div className="field col-6 me-2">
                <span className="p-float-label">
                  <InputText
                    name="NombreCategoria"
                    value={values.NombreCategoria}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    abelStyle={{
                      color: "gray",
                      textShadow: "0px 0px 1px white",
                    }}
                    className={error.NombreCategoria ? "p-invalid" : ""}
                  />
                  <label htmlFor="NombreCategoria">Nombre de Categoría</label>
                </span>
              </div>

              <div className="field col-6 me-2">
                <span className="p-float-label">
                  <AutoCompleteDropdown
                    name={"Tipo"}
                    value={values.Tipo}
                    items={tiposCategoria}
                    field={"Type"}
                    label={"Tipo"}
                    handleInputChange={handleInputChange}
                    abelStyle={{
                      color: "gray",
                      textShadow: "0px 0px 1px white",
                    }}
                    className={error.IdType ? "p-invalid" : ""}
                  />
                </span>
              </div>
            </div>

            <div className="modal__input-contenedor mt-3">
              <div className="field col-6 me-2">
                <span className="p-float-label">
                  <InputText
                    name="Comentario"
                    value={values.Comentario}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    className={error.Comentario ? "p-invalid" : ""}
                  />
                  <label htmlFor="Comentario">Comentario</label>
                  {error.Comentario && (
                    <small className="p-error">
                      El Comentario solo puede contener letras, números,
                      espacios y los caracteres '.', '_', '-'.
                    </small>
                  )}
                </span>
              </div>
              <div className="field col-6 me-2">
                <span className="p-float-label">
                  <AutoCompleteDropdown
                    name={"Estado"}
                    value={values.Estado}
                    items={estados}
                    field={"StatusName"}
                    label={"Estado"}
                    handleInputChange={handleInputChange}
                    abelStyle={{
                      color: "gray",
                      textShadow: "0px 0px 1px white",
                    }}
                    className={error.IdStatus ? "p-invalid" : ""}
                  />
                </span>
              </div>
            </div>

            <div className="modal__input-contenedor mt-3">
              <div className="field col-6">
                  <span className="p-float-label">
                    <Checkbox
                      checked={values.EsServicio}
                      onChange={(e) =>
                        setValues({
                          ...values,
                          EsServicio: e.target.checked,
                        })
                      }
                    />
                    <label htmlFor="Estado">
                      &nbsp;&nbsp;&nbsp;&nbsp;Es Servicio
                    </label>
                  </span>
              </div>
            </div>
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default CategoriasCrudModal;
